"use strict";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.preKeyupBehavior = exports.preKeydownBehavior = exports.postKeyupBehavior = exports.keyupBehavior = exports.keypressBehavior = exports.keydownBehavior = void 0;

var _dom = require("@testing-library/dom");

var _utils = require("../../utils");

var _getEventProps = require("../getEventProps");

var _shared = require("../shared");
/**
 * This file should contain behavior for functional keys as described here:
 * https://w3c.github.io/uievents-code/#key-alphanumeric-functional
 */


var modifierKeys = {
  Alt: 'alt',
  Control: 'ctrl',
  Shift: 'shift',
  Meta: 'meta'
};
var preKeydownBehavior = [].concat(_toConsumableArray(Object.entries(modifierKeys).map(function (_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      modKey = _ref2[1];

  return {
    matches: function matches(keyDef) {
      return keyDef.key === key;
    },
    handle: function handle(keyDef, element, options, state) {
      state.modifiers[modKey] = true;
    }
  };
})), [// AltGraph produces an extra keydown for Control
// The modifier does not change
{
  matches: function matches(keyDef) {
    return keyDef.key === 'AltGraph';
  },
  handle: function handle(keyDef, element, options, state) {
    var _options$keyboardMap$;

    var ctrlKeyDef = (_options$keyboardMap$ = options.keyboardMap.find(function (k) {
      return k.key === 'Control';
    })) != null ? _options$keyboardMap$ :
    /* istanbul ignore next */
    {
      key: 'Control',
      code: 'Control'
    };

    _dom.fireEvent.keyDown(element, (0, _getEventProps.getKeyEventProps)(ctrlKeyDef, state));
  }
}]);
exports.preKeydownBehavior = preKeydownBehavior;
var keydownBehavior = [{
  matches: function matches(keyDef) {
    return keyDef.key === 'CapsLock';
  },
  handle: function handle(keyDef, element, options, state) {
    state.modifiers.caps = !state.modifiers.caps;
  }
}, {
  matches: function matches(keyDef, element) {
    return keyDef.key === 'Backspace' && (0, _utils.isEditable)(element) && !(0, _utils.isCursorAtStart)(element);
  },
  handle: function handle(keyDef, element, options, state) {
    var _ref3 = (0, _utils.calculateNewValue)('', element, state.carryValue, undefined, 'backward'),
        newValue = _ref3.newValue,
        newSelectionStart = _ref3.newSelectionStart;

    (0, _shared.fireInputEvent)(element, {
      newValue: newValue,
      newSelectionStart: newSelectionStart,
      eventOverrides: {
        inputType: 'deleteContentBackward'
      }
    });
    (0, _shared.carryValue)(element, state, newValue);
  }
}];
exports.keydownBehavior = keydownBehavior;
var keypressBehavior = [{
  matches: function matches(keyDef, element) {
    return keyDef.key === 'Enter' && (0, _utils.isElementType)(element, 'input') && ['checkbox', 'radio'].includes(element.type);
  },
  handle: function handle(keyDef, element) {
    var form = element.form;

    if ((0, _utils.hasFormSubmit)(form)) {
      _dom.fireEvent.submit(form);
    }
  }
}, {
  matches: function matches(keyDef, element) {
    return keyDef.key === 'Enter' && ((0, _utils.isClickableInput)(element) || // Links with href defined should handle Enter the same as a click
    (0, _utils.isElementType)(element, 'a') && Boolean(element.href));
  },
  handle: function handle(keyDef, element, options, state) {
    _dom.fireEvent.click(element, (0, _getEventProps.getMouseEventProps)(state));
  }
}, {
  matches: function matches(keyDef, element) {
    return keyDef.key === 'Enter' && (0, _utils.isElementType)(element, 'input');
  },
  handle: function handle(keyDef, element) {
    var form = element.form;

    if (form && (form.querySelectorAll('input').length === 1 || (0, _utils.hasFormSubmit)(form))) {
      _dom.fireEvent.submit(form);
    }
  }
}];
exports.keypressBehavior = keypressBehavior;

var preKeyupBehavior = _toConsumableArray(Object.entries(modifierKeys).map(function (_ref4) {
  var _ref5 = _slicedToArray(_ref4, 2),
      key = _ref5[0],
      modKey = _ref5[1];

  return {
    matches: function matches(keyDef) {
      return keyDef.key === key;
    },
    handle: function handle(keyDef, element, options, state) {
      state.modifiers[modKey] = false;
    }
  };
}));

exports.preKeyupBehavior = preKeyupBehavior;
var keyupBehavior = [{
  matches: function matches(keyDef, element) {
    return keyDef.key === ' ' && (0, _utils.isClickableInput)(element);
  },
  handle: function handle(keyDef, element, options, state) {
    _dom.fireEvent.click(element, (0, _getEventProps.getMouseEventProps)(state));
  }
}];
exports.keyupBehavior = keyupBehavior;
var postKeyupBehavior = [// AltGraph produces an extra keyup for Control
// The modifier does not change
{
  matches: function matches(keyDef) {
    return keyDef.key === 'AltGraph';
  },
  handle: function handle(keyDef, element, options, state) {
    var _options$keyboardMap$2;

    var ctrlKeyDef = (_options$keyboardMap$2 = options.keyboardMap.find(function (k) {
      return k.key === 'Control';
    })) != null ? _options$keyboardMap$2 :
    /* istanbul ignore next */
    {
      key: 'Control',
      code: 'Control'
    };

    _dom.fireEvent.keyUp(element, (0, _getEventProps.getKeyEventProps)(ctrlKeyDef, state));
  }
}];
exports.postKeyupBehavior = postKeyupBehavior;